import type { WebediaPlayer } from '@webedia-services/webedia-player';

import { BRAND_HAS_DM_PLAYER } from 'common/configuration/constants';
import { PostrollAsVideoConfig } from 'common/module/advertisement/types';

import {
  COMSCORE_CLIENT_ID,
  GEMIUS_IDENTIFIER,
  GEMIUS_LIB_URL,
  GEMIUS_PREFIX,
  GTM_PLAYER_ACTIVE,
  MEDIAMETRIE_LIB_URL,
  MEDIAMETRIE_STREAMING_SERIAL
} from 'website/configuration/constants';
import type { PlayerCustomData } from 'website/module/player';
import initGtm from 'website/tracking/player//gtm';
import initComscore from 'website/tracking/player/comscore';
import initGemius from 'website/tracking/player/gemius';
import initJan from 'website/tracking/player/jan';
import initMediametrie from 'website/tracking/player/mediametrie';

export type ExtraProps = {
  customParams?: string;
  postrollConfig?: PostrollAsVideoConfig;
};

const initTrackingPlayer = (
  webediaPlayer: WebediaPlayer,
  customData: PlayerCustomData,
  playerName: string,
  extra: ExtraProps
) => {
  initJan(webediaPlayer, customData, extra);

  if (GTM_PLAYER_ACTIVE) {
    initGtm(webediaPlayer, customData);
  }

  if (
    !BRAND_HAS_DM_PLAYER &&
    MEDIAMETRIE_LIB_URL &&
    MEDIAMETRIE_STREAMING_SERIAL
  ) {
    initMediametrie(webediaPlayer, customData, playerName);
  }

  if (COMSCORE_CLIENT_ID) {
    initComscore(webediaPlayer, customData);
  }

  if (GEMIUS_LIB_URL && GEMIUS_PREFIX && GEMIUS_IDENTIFIER) {
    initGemius(webediaPlayer, customData);
  }
};

export default initTrackingPlayer;
